module.exports = __webpack_public_path__ + "static/img/kids-thankyou-mobile.67535e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kids-thankyou-mobile.png
// module id = 343
// module chunks = 0